import { useEffect } from "react";
import { DashboardIndex } from "@Src/features/Dashboard"
import { useLocation, useNavigate } from "react-router-dom";
import { AppRouteURL } from "@Constants/app-route-url.constant";


export const Dashboard = () => {
    const location=useLocation();
    const navigate=useNavigate();
    useEffect(()=>{
        if(!(location.pathname.startsWith(AppRouteURL.DASHBOARD)) || location.pathname.endsWith(AppRouteURL.DASHBOARD)){
            navigate(AppRouteURL.NOT_FOUND)
        }
    },[location.pathname])
    useEffect(() => {
    document.body.classList.add("tw-overflow-hidden");
    return () => document.body.classList.remove("tw-overflow-hidden");
}, []);


    return (
        <>
         <DashboardIndex />
        </>
    )
}